const isPlainObject = (value) => value && typeof value === "object" && !Array.isArray(value);

const tableNestedArrays = (value, path = "") => {
  if (Array.isArray(value)) {
    // If it's an array of objects, print the table
    if (value.length && value.every(isPlainObject)) {
      console.log(path || "items");
      console.table(value);
    }
    // Always recurse through array items
    value.forEach((item, index) => tableNestedArrays(item, `${path}[${index}]`));
    
  } else if (isPlainObject(value)) {
    // Recurse through object properties
    Object.entries(value).forEach(([key, child]) => {
      tableNestedArrays(child, path ? `${path}.${key}` : key);
    });
  }
};

export default (payload) => {
  console.log("payload:", payload);
  console.table(payload);
  tableNestedArrays(payload);
};